import { createTheme } from '@mui/material/styles';
import { red, grey } from '@mui/material/colors';

// Dark Theme
const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#ff6d0f', // Keep the primary color for consistency
      contrastText: '#fff',
    },
    secondary: {
      main: '#19857b',
    },
    background: {
      default: '#1e1e1e', // Darker background for the main layout
      paper: '#292929', // Dark background for sidebar and cards
    },
    text: {
      primary: '#fff', // Lighter text color
      secondary: grey[400],
    },
    error: {
      main: red.A400,
    },
  },
  typography: {
    fontFamily: 'Roboto, sans-serif',
  },
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: '1rem', // Tooltip font size
          backgroundColor: 'rgba(0, 0, 0, 0.87)', // Tooltip background color
          color: '#fff', // Tooltip text color
        },
        arrow: {
          color: 'rgba(0, 0, 0, 0.87)', // Tooltip arrow color
        },
      },
    },
  },
});

export default darkTheme;
